import { c as _c } from "react/compiler-runtime";
import { FunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/funnel-step-actions';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useWebinarRegistrationSettings } from 'modules/funnels/funnel/hooks/use-webinar-registration-settings';
import type { FunnelStepPageActionsProps } from 'modules/funnels/funnel/types/funnel-step-page-actions-props';
import { getStepPreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
function WebinarRegistrationFunnelStepActions(t0) {
  const $ = _c(9);
  const {
    funnelId,
    funnelStep,
    pageId
  } = t0;
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    webinarRegistrationSettings
  } = useWebinarRegistrationSettings(funnelStep.id);
  let t1;
  if ($[0] !== funnel || $[1] !== funnelStep.inRunningSplitTest || $[2] !== webinarRegistrationSettings) {
    t1 = funnel && webinarRegistrationSettings ? getStepPreviewUrl(funnel.domain.domainName, webinarRegistrationSettings.page.path, funnelStep.inRunningSplitTest) : undefined;
    $[0] = funnel;
    $[1] = funnelStep.inRunningSplitTest;
    $[2] = webinarRegistrationSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const viewLinkUrl = t1;
  let t2;
  if ($[4] !== funnelId || $[5] !== funnelStep.id || $[6] !== pageId || $[7] !== viewLinkUrl) {
    t2 = <FunnelStepActions funnelId={funnelId} funnelStepId={funnelStep.id} pageId={pageId} viewLinkUrl={viewLinkUrl} />;
    $[4] = funnelId;
    $[5] = funnelStep.id;
    $[6] = pageId;
    $[7] = viewLinkUrl;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export { WebinarRegistrationFunnelStepActions };